export default __webpack_public_path__ + "static/media/pic2.9afc561a.png";